import { searchInitialState } from '@modules/feed/store/searchInitialState';
import { getCombinedFeedAndDashboardFilters } from '@modules/feed/utils';
import { FeedActionType } from './searchActionType';
import { SearchAction, SearchState } from './types';

export function searchReducer(
  state: SearchState,
  action: SearchAction,
): SearchState {
  switch (action.type) {
    case FeedActionType.SET_VISUAL: {
      return {
        ...state,
        visual: {
          ...state.visual,
          ...action.payload,
        },
      };
    }

    case FeedActionType.SET_QUERY: {
      const updatedQuery = state.query
        ? {
            ...state.query,
            ...action.payload,
          }
        : { ...searchInitialState.query, ...action.payload };

      return {
        ...state,
        query: updatedQuery,
        visual: {
          ...state.visual,
          feedAndDashboardFilters: getCombinedFeedAndDashboardFilters({
            primaryQuery: updatedQuery,
            dashboardFilters: state.visual.dashboardFilters,
          }),
          hasChangesToBeSaved: true,
        },
      };
    }

    case FeedActionType.SET_UPDATE_QUERY: {
      const updatedQuery = state.query
        ? {
            ...state.query,
            ...action.payload,
          }
        : { ...searchInitialState.query, ...action.payload };

      return {
        ...state,
        query: updatedQuery,
        visual: {
          ...state.visual,
          feedAndDashboardFilters: getCombinedFeedAndDashboardFilters({
            primaryQuery: updatedQuery,
            dashboardFilters: state.visual.dashboardFilters,
          }),
          hasChangesToBeSaved: false,
        },
      };
    }

    case FeedActionType.SET_PROMPT: {
      return {
        ...state,
        prompt: action.payload,
      };
    }

    case FeedActionType.RESET: {
      return searchInitialState;
    }

    default:
      return state;
  }
}
